type Primitive = string | number | boolean | null | undefined;
type ObjectOfPrimitives = { [key: string]: Primitive | Primitive[] | undefined };

export const createParams = (params: ObjectOfPrimitives) =>
  Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null)
    .map(([key, value]) =>
      Array.isArray(value) ? value.map((item) => `${key}=${item}`).join('&') : `${key}=${value}`
    )
    .join('&');
